import classNames from 'classnames'

import { getQualityBand } from '../../helpers/getQualityBand'
import type { TQualityBand } from '../../models'

import styles from './ProgressBar.module.scss'

interface IProgressBarProps {
  value: number
  target?: number
  band?: TQualityBand
}

export const ProgressBar = ({ value, target = 100, band: bandOverride }: IProgressBarProps) => {
  const percent = target > 0 ? (value / target) * 100 : 0
  const progressWidth = Math.min(Math.max(percent, 0), 100)

  const hasOverflow = target > 0 && value > target

  const total = Math.max(value, target)
  const targetWidth = hasOverflow ? (target / total) * 100 : 0
  const overflowWidth = hasOverflow ? ((value - target) / total) * 100 : 0

  const band = bandOverride ?? getQualityBand(percent)

  return (
    <div className={styles.track}>
      {overflowWidth > 0 ? (
        <>
          <div className={styles.target} style={{ width: `${targetWidth}%` }} />
          <div className={styles.overflow} style={{ width: `${overflowWidth}%` }} />
        </>
      ) : (
        <div
          className={classNames(styles.value, band && styles[`value--${band}`])}
          style={{ width: `${progressWidth}%` }}
        />
      )}
    </div>
  )
}
